import React from 'react'

import { GetServerSidePropsContext } from 'next'
import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import useTranslation from 'next-translate/useTranslation'

import { Text } from '@/components/Text'
import { Path } from '@/components/Path'
import { PageLayout } from '@/components/Layout/PageLayout'

import { initializeStore } from '@/redux/store'
import { getSettings } from '@/redux/actions'

import { ColorsMap, FontWeightMap } from '@/utils/Theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 14%;
  margin-bottom: 4rem;
`

const BoldText = styled.span`
  font-weight: ${FontWeightMap.bold};
`

const TermsContent = ({ lang }) => {
  switch (lang) {
    case 'sk':
      return (
        <>
          <Text fontSize="xl" textColor={ColorsMap.primary} fontWeight="bold" m="2.5rem auto">
            Všeobecné obchodné podmienky
          </Text>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            I. Všeobecné ustanovenia
          </Text>
          <Text>
            1. Tieto všeobecné obchodné podmienky sa vzťahujú na obchodné vzťahy medzi kupujúcim a predávajúcim:{' '}
            <BoldText>SINTRA šport, s.r.o.</BoldText>, Pluhová 2, 831 03 Bratislava, IČO: 35935448, DIČ: 2022001839, IČ
            DPH: SK2022001839, spoločnosť je zapísaná v OR: Okresného súdu Bratislava 1, Oddiel Sro, vložka č.: 36034/B
            (ďalej len predávajúcim a kupujúcim). Názov organizácie dozoru: SOI, Prievozská 22, Bratislava.
          </Text>
          <br />
          <p>
            2. Podmienky bližšie vymedzujú a&nbsp;upresňujú práva a&nbsp;povinnosti predávajúceho a&nbsp;kupujúceho
            a&nbsp;vo svojom aktuálnom znení tvoria neoddeliteľnú súčasť kúpnej zmluvy. V&nbsp;prípade, ak nie je medzi
            predávajúcim a&nbsp;kupujúcim dohodnutá trvalá kúpna zmluva v&nbsp;písomnej forme, považuje sa elektronická
            objednávka v&nbsp;e-shope za návrh k&nbsp;uzavretiu zmluvy medzi kupujúcim a&nbsp;predávajúcim, ktorú
            predávajúci potvrdením objednávky akceptuje.
          </p>
          <br />
          <p>
            3. Predávajúci je oprávnený zmeniť obchodné podmienky, ktoré nadobúdajú platnosť a&nbsp;účinnosť dňom ich
            uverejnenia na internetovej stránke. Zmluvné vzťahy, ktoré vznikli pred účinnosťou nových obchodných
            podmienok sa riadna obchodnými podmienkami platnými a&nbsp;účinnými do vzniku týchto zmluvných vzťahov.
          </p>
          <br />
          <p>
            4.&nbsp;
            <BoldText>Predávajúcim&nbsp;</BoldText>
            sa rozumie prevádzkovateľ e-shopu.
          </p>
          <br />
          <Text>
            5.&nbsp;
            <BoldText>Kupujúcim</BoldText>
            &nbsp;sa rozumie fyzická alebo právnická osoba, ktorá prostredníctvom nákupného košíka odoslala po vlastnej
            autorizácii elektronickú objednávku, spracovanú systémom&nbsp;&nbsp;e-shopu.
          </Text>
          <Text>
            <br />
            6.&nbsp;
            <BoldText>Tovarom</BoldText>
            &nbsp;sa rozumejú všetky produkty uvedené v&nbsp;platnom prehľade na stránkach e-shopu.
          </Text>
          <br />
          <p>
            7.&nbsp;
            <BoldText>Elektronickou objednávkou</BoldText>
            &nbsp;sa rozumie odoslaný elektronický formulár, obsahujúci informácie o&nbsp;kupujúcom, zoznam objednaného
            tovaru z&nbsp;ponuky obchodu a&nbsp;cenu tohto tovaru, spracovaný systémom obchodu.
          </p>
          <br />
          <p>
            8.&nbsp;
            <BoldText>Registráciou&nbsp;</BoldText>
            sa rozumie zaregistrovanie zákazníka pred objednávkou tovaru.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            II. Objednávanie tovaru
          </Text>
          <p>
            1. Objednávanie v&nbsp;e-shope sa uskutočňuje prostredníctvom&nbsp;
            <BoldText>nákupného košíka</BoldText>.
          </p>
          <br />
          <p>
            2. Pri objednávke tovaru kupujúci vyplní povinné polia vo formulári, inak objednávku nie je možné potvrdiť.
          </p>
          <br />
          <p>3. Objednávky sú do systému zaraďované podľa poradia, v&nbsp;akom prichádzajú.</p>
          <br />
          <p>
            4. Podmienkou platnosti elektronickej objednávky je&nbsp;
            <BoldText>pravdivé</BoldText>
            &nbsp;a&nbsp;
            <BoldText>úplné</BoldText>
            &nbsp;vyplnenie&nbsp;
            <BoldText>všetkých</BoldText>
            ,&nbsp;registračným formulárom požadovaných údajov a&nbsp;náležitostí, ktoré umožnia bezproblémové doručenie
            zásielky.
          </p>
          <br />
          <p>
            5. Všetky prijaté elektronické objednávky sú považované za&nbsp;
            <BoldText>návrh na uzatvorenie zmluvy</BoldText>
            &nbsp;a&nbsp;sú záväzné.
          </p>
          <br />
          <p>
            6. Potvrdením elektronickej objednávky systémom dôjde k&nbsp;akceptácii návrhu na uzatvorenie zmluvy
            predávajúcim. Momentom akceptácie návrhu na uzatvorenie zmluvy dôjde k&nbsp;vlastnému uzavretiu kúpnej
            zmluvy medzi predávajúcim a&nbsp;kupujúcim. Účinnosť akceptácie nastáva okamihom prevzatia a&nbsp;zaplatenia
            tovaru kupujúcim.
          </p>
          <br />
          <p>
            7. Pokiaľ objednávaný tovar nie je na sklade a&nbsp;nebude ho možné z&nbsp;rôznych dôvodov doobjednať tak,
            aby bol kupujúcemu doručený v&nbsp;rámci dodacej lehoty, upozorní predávajúci kupujúceho e-mailom alebo
            telefonicky na dané skutočnosti. Kupujúci má právo v&nbsp;takomto prípade svoju objednávku zrušiť alebo
            upraviť podľa vzájomnej dohody.
          </p>
          <br />
          <p>
            8.
            <BoldText>&nbsp;Hodnota</BoldText>
            &nbsp;tovaru uvedená na potvrdenej objednávke je&nbsp;
            <BoldText>konečná.</BoldText>
          </p>
          <br />
          <p>&nbsp;</p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            III. Ceny tovaru
          </Text>
          <p>
            1. Ceny tovarov sú dané pri každom výrobku v&nbsp;e-shope v&nbsp;EUR s&nbsp;DPH. Predávajúci sa zaväzuje
            dodržať ceny dané v&nbsp;potvrdenej objednávke kupujúceho.
          </p>
          <br />
          <p>
            2. Predávajúci má právo ceny aktualizovať a&nbsp;meniť v&nbsp;prípade zmien cien na trhu alebo od svojho
            dodávateľa a&nbsp;pod. aj bez upozornenia.
          </p>
          <p>&nbsp;</p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            IV. Spôsob platby
          </Text>
          <p>1. Platby za tovar sa uskutočňujú v&nbsp;hotovosti, resp. dobierkou kuriérovi pri doručení tovaru.</p>
          <br />
          <p>2. Kupujúci dostáva faktúru ako daňový doklad, ktorú je v&nbsp;prípade reklamácie potrebné predložiť.</p>
          <br />
          <p>&nbsp;</p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            V. Dodávka tovaru
          </Text>
          <p>
            1. Miestom plnenia zmluvy sa rozumie sídlo (bydlisko) alebo miesto podnikania kupujúceho uvedené
            v&nbsp;registračnom formulári. Tovar objednaný kupujúcim bude dodaný kupujúcemu prostredníctvom služieb
            tretích subjektov.
          </p>
          <br />
          <p>
            2. Predávajúci dodá tovar kupujúcemu v&nbsp;lehote&nbsp;
            <BoldText>1&nbsp;-&nbsp;14</BoldText>
            &nbsp;
            <BoldText>pracovných&nbsp;</BoldText>
            dní. Doba pre dodanie tovaru môže byť vo výnimočných prípadoch dlhšia, o&nbsp;čom bude kupujúci včas
            informovaný.
          </p>
          <br />
          <p>
            3. Predávajúci k&nbsp;hodnote tovaru zaslaného prostredníctvom kuriérskej služby účtuje poplatok vo výške{' '}
            <BoldText>5,-&nbsp;&euro; s DPH </BoldText>
            za dopravu,
            <BoldText>pri objednávke nad 100,- &euro;&nbsp;preprava zadarmo.</BoldText>
          </p>
          <br />
          4. V&nbsp;prípade, že objednávka nemôže byť jednorazovo úplne vybavená, kupujúci zaplatí poštovné podľa
          čiastky uvedenej v&nbsp;objednávke. Za dodatočne zaslaný tovar z&nbsp;čiastočne vybavenej objednávky sa
          poštovné&nbsp;a dobierečné <BoldText>neplatí.</BoldText> <br />
          <p>
            5. Kuriérska spol. ručí za zásielku do okamihu jej odovzdania kupujúcemu. Ten si je povinný prezrieť&nbsp;
            <BoldText>
              zásielku pri preberaní a&nbsp;v&nbsp;prípade viditeľného poškodenia, či dokonca straty časti tovaru, spíše
              s&nbsp;dopravcom reklamačný protokol a&nbsp;zásielku nepreberie
            </BoldText>
            .&nbsp;Hneď ako kuriérska spol. zásielku vráti, predávajúci vyexpeduje nový tovar kupujúcemu.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            VI. Vrátenie tovaru
          </Text>
          <p>
            1. Kupujúci má právo tovar vrátiť bez udania dôvodu do&nbsp;
            <BoldText>14 dní</BoldText>
            &nbsp;od doručenia tovaru. Spotrebiteľ môže uplatniť právo na odstúpenie od zmluvy u predávajúceho v
            listinnej podobe alebo e-mailom na adrese
            <u>
              <a href="mailto:kalo@tn.sintra.sk"> ivana@tn.sintra.sk </a>
            </u>
            . Spotrebiteľ môže použiť
            <a href="https://data.werco.cz/eshop_sk/dokumenty/odstupenie_spotrebitela_od_zmluvy.pdf">
              <strong> formulár na odstúpenie od zmluvy</strong>
            </a>
            . Ak sa takto rozhodnete, zašlite nám spolu s tovarom písomné prehlásenie o odstúpení od zmluvy s uvedením
            čísla objednávky, dátumu nákupu a čísla účtu pre finančné vysporiadanie. V&nbsp;takomto prípade zašle
            kupujúci tovar spolu s dokladom o kúpe najneskôr do 14 dní od dňa odstúpenia od zmluvy späť poštou na adresu
            sídla:&nbsp;
            <BoldText>SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín.</BoldText>
          </p>
          <br />
          <p>
            Prípadne odovzdajte tovar osobne na predajni (výdajnom mieste). Pri vrátení zasielajte (odovzdajte) prosím
            tovar nepoškodený vrátane dokumentácie, príslušenstva a pod. Pri odstúpení od zmluvy znášate iba náklady na
            vrátenie tovaru predávajúcemu. Spotrebiteľ zodpovedá za zníženie hodnoty tovaru, ktoré vzniklo v dôsledku
            takého zaobchádzania s tovarom, ktoré je nad rámec zaobchádzania potrebného na zistenie vlastností a
            funkčnosti tovaru.
          </p>
          <br />
          <p>
            Predávajúci sa zaväzuje vrátiť cenu zaplatenú za príslušný tovar v lehote 14&nbsp;dní odo dňa doručenia
            oznámenia o odstúpení od zmluvy predávajúcemu.
          </p>
          <br />
          <p>2. Vrátený tovar kupujúci nezasiela na dobierku!</p>
          <br />
          <p>
            3. Po dohode môže byť vrátenie sumy uskutočnené formou výmeny za iný tovar v&nbsp;zodpovedajúcej hodnote,
            ktorý bude zaslaný buď s&nbsp;ďalšou objednávkou zákazníka alebo samostatne. Ak sa tovar zasiela samostatne
            (v prípade výmeny tovaru) poštovné nebude&nbsp;
            <BoldText>účtované</BoldText>
            ,&nbsp;avšak iba v&nbsp;prípade, že sa jedná o&nbsp;jeho&nbsp;
            <BoldText>prvú</BoldText>
            &nbsp;výmenu.
          </p>
          <br />
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            VII. Reklamácia tovaru
          </Text>
          <p>
            1. Kupujúci je povinný všetok dodaný tovar prezrieť a&nbsp;bez zbytočného odkladu po dodaní skontrolovať
            jeho úplnosť. Akýkoľvek nesúlad medzi dodaným tovarom a&nbsp;tovarom uvedenom na sprievodnom doklade je
            kupujúci povinný oznámiť
            <BoldText> bezodkladne </BoldText>
            predávajúcemu. <br />
            <br />
            2. Kupujúci reklamovaný výrobok zašle spolu s&nbsp;kópiou faktúry na adresu predávajúceho:&nbsp;
            <BoldText>SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín</BoldText>
            <br />
            <br />
            3. Reklamácie tovaru budú vybavované v&nbsp;súlade s&nbsp;Občianskym zákonníkom Slovenskej republiky
            a&nbsp;zákonom č. 250/2007 Z. z. o&nbsp;ochrane spotrebiteľa v&nbsp;znení neskorších predpisov.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            VIII. Záverečné ustanovenia
          </Text>
          1. Právne vzťahy a&nbsp;podmienky tu výslovne neupravené, ako aj prípadné spory vzniknuté z&nbsp;neplnenia
          týchto podmienok sa riadia príslušnými ustanoveniami Občianskeho zákonníka Slovenskej republiky. Práva
          kupujúceho vo vzťahu k&nbsp;predávajúcemu vyplývajúce zo zákona č. 250/2007 Z.z. o&nbsp;ochrane spotrebiteľa
          v&nbsp;znení neskorších právnych predpisov zostávajú týmito podmienkami nedotknuté.
          <br />
          <p>
            2. Predávajúci ani odberateľ nezodpovedá za oneskorené plnenie svojich záväzkov vyplývajúcich z&nbsp;týchto
            podmienok, ak takéto oneskorenie bolo spôsobené &quot;vyššou mocou&quot; alebo okolnosťami vylučujúcimi
            zodpovednosť, a&nbsp;takáto strana má právo na primerané predĺženie lehoty pri plnení svojich záväzkov.
          </p>
          <br />
          <p>
            3. Kupujúci vyhlasuje, že súhlasí v&nbsp;zmysle ust. &sect; 7&nbsp;ods. 1&nbsp;zákona č. 428/2002 Z.z.
            o&nbsp;ochrane osobných údajov v&nbsp;znení neskorších predpisov, so spracovaním a&nbsp;uchovávaním osobných
            údajov, ktoré sú potrebné pri činnosti predávajúceho a&nbsp;spracovávaním ich vo všetkých svojich
            informačných systémoch. Predávajúci sa zaväzuje, že bude s&nbsp;osobnými údajmi kupujúceho zaobchádzať
            a&nbsp;nakladať v&nbsp;súlade s&nbsp;platnými právnymi predpismi SR. Kupujúci udeľuje predávajúcemu tento
            súhlas na dobu neurčitú.
          </p>
          <br />
          <p>
            4. Kupujúci súhlasí s&nbsp;poskytovaním osobných údajov spoločnosti&nbsp;
            <BoldText>SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín</BoldText>
            ,&nbsp;ktoré sú potrebné pri jej činnosti, a&nbsp;to najmä na činnosti uvedené v&nbsp;Obchodnom registri.
            Súhlas so spracovaním osobných údajov môže kupujúci odvolať kedykoľvek písomnou formou. Súhlas zanikne
            v&nbsp;lehote 1&nbsp;mesiaca od doručenia odvolania súhlasu kupujúcim predávajúcemu.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            Reklamačný poriadok
          </Text>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            I. Všeobecné ustanovenia
          </Text>
          1. Predávajúci zodpovedá za vady, ktoré má predaná vec pri jej prevzatí kupujúcim. Pri použitých veciach
          nezodpovedá predávajúci za vady vzniknuté ich použitím alebo opotrebením. Pri veciach predávaných za nižšiu
          cenu nezodpovedá predávajúci za vadu, pre ktorú bola dojednaná nižšia cena.
          <br />
          <br />
          2. Vlastnícke právo kúpenej veci prechádza na kupujúceho okamihom zaplatenia kúpnej ceny za tovar. Pri
          samoobslužnom predaji dochádza k&nbsp;prevodu vlastníckeho práva ku kúpenej veci okamihom zaplatenia kúpnej
          ceny za tovar.
          <br />
          <br />
          3. Kupujúci je povinný po prevzatí tovaru skontrolovať jeho množstvo, kvalitu a&nbsp;balenie a&nbsp;neodkladne
          (bez zbytočného odkladu) oznámiť predajcovi prípadné nedostatky. (&sect;599 OZ)
          <br />
          <br />
          4. Záruka sa vzťahuje len na výrobok uvedený na dodacom liste a&nbsp;faktúre a&nbsp;týka sa všetkých vád
          zistených v&nbsp;záručnej dobe spôsobených chybou materiálu, chybnou konštrukciou, alebo chybným spracovaním.
          Záruka sa vzťahuje na skryté vady na predmete dodávky, ale nevzťahuje sa na vady, ktoré vznikli neodbornou
          manipuláciou alebo neodborným zásahom na tovare po jeho odovzdaní kupujúcemu alebo jeho zástupcovi. Následné
          poškodenie povrchu predmetu dodávky škrabnutím a&nbsp;pod. sa nepovažuje za skrytú vadu. (&sect;&nbsp;619 OZ)
          <br />
          <br />
          5. Nadobudnutím vlastníckeho práva prechádza na kupujúceho nebezpečenstvo náhodnej skazy, zničenia
          a&nbsp;poškodenia veci.
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            II. Lehoty na uplatnenie reklamácie
          </Text>
          1. Záruka na tovar je 24 mesiacov. Záručné doby začínajú plynúť od dátumu prevzatia tovaru kupujúcim
          (&nbsp;&sect; 621 Občianskeho zákonníka ďalej len &bdquo; OZ&ldquo;). Záručná doba sa vzťahuje aj na výrobky
          predávané vo výpredajoch, či so zľavou. Ak je však poskytnutá zľava kvôli určitej vade tovaru, túto vadu potom
          nie je možné reklamovať. (&sect;&nbsp;619 OZ)
          <br />
          <br />
          2. Ak je na predávanom tovare, jeho obale alebo návode vyznačená lehota na použitie (expiračná doba), záručná
          lehota sa neskončí pred uplynutím tejto lehoty.
          <br />
          <br />
          3. Ak sa na predávaný tovar vzťahuje záručná lehota dlhšia ako 24 mesiacov je predávajúci povinný vydať
          kupujúcemu pri predaji záručný list s&nbsp;vyznačením záručnej lehoty. V&nbsp;záručnom liste sú uvedené
          podmienky a&nbsp;rozsah tejto záruky.
          <br />
          <br />
          4. Práva zo zodpovednosti za vady musí kupujúci uplatniť v&nbsp;záručnej lehote, inak tieto práva zanikajú.
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            III. Strata nároku na nároky zo záruky
          </Text>
          <p>
            Nároky plynúce zo záruky zanikajú, ak tovar bol :<br />
            &middot; poškodený prepravou spotrebiteľa,
            <br />
            &middot; mechanicky poškodený neodbornou manipuláciou, alebo zlým skladovaním po prevzatí tovaru,
            <br />
            &middot; zašpinený a&nbsp;neodborne vyčistený,
            <br />
            &middot; poškodený neodborným zásahom do jeho konštrukcie,
            <br />
            &middot; znehodnotený nadmerným používaním alebo bol používaný na iný účel než sa bežne používa,
            <br />
            &middot; poškodený od domácich zvierat a&nbsp;pod...
          </p>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            IV. Miesto uplatnenia reklamácie
          </Text>
          <p>
            1. Zjavné vady treba neodkladne reklamovať v&nbsp;sídle predávajúceho
            <br />
            <Text as="span" my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
              SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín
            </Text>
            <br />
            &nbsp;(reklamačné miesto) predložením dokladu o&nbsp;zakúpení a&nbsp;zaplatení tovaru .&nbsp;(&nbsp;&sect;18
            ods. 1&nbsp;zákona o&nbsp;ochrane spotrebiteľa ďalej len &bdquo; ZOS&ldquo;)
            <br />
            <br />
            2. Predávajúci je povinný vybaviť reklamáciu ihneď, v&nbsp;zložitých prípadoch do 3&nbsp;pracovných dní
            a&nbsp;v&nbsp;odôvodnených prípadoch do 30 dní od uplatnenia reklamácie &sect; 18 ods. 4&nbsp;ZOS cit:
            &bdquo; Ak spotrebiteľ uplatní reklamáciu, predávajúci alebo ním poverený zamestnanec alebo určená osoba je
            povinný poučiť spotrebiteľa o&nbsp;jeho právach podľa všeobecného predpisu. Na základe rozhodnutia
            spotrebiteľa, ktoré z&nbsp;týchto práv spotrebiteľ uplatňuje, je povinný určiť spôsob vybavenia reklamácie
            podľa &sect; 2&nbsp;písm. m) ihneď, v&nbsp;zložitých prípadoch najneskôr do 3&nbsp;pracovných dní odo dňa
            uplatnenia reklamácie, v&nbsp;odôvodnených prípadoch, najmä ak sa vyžaduje zložité technické zhodnotenie
            stavu výrobku alebo služby, najneskôr do 30 dní odo dňa uplatnenia reklamácie. Po určení spôsobu vybavenia
            reklamácie sa reklamácia vybaví ihneď, v&nbsp;odôvodnených prípadoch možno reklamáciu vybaviť aj neskôr;
            vybavenie reklamácie však nesmie trvať dlhšie ako 30 dní odo dňa uplatnenia reklamácie. Po uplynutí lehoty
            na vybavenie reklamácie má spotrebiteľ právo od zmluvy odstúpiť alebo má právo na výmenu výrobku za nový
            výrobok.&ldquo;
            <br />
            <br />
            3. Vybavenie reklamácie nesmie trvať dlhšie ako 30 dní (&sect; 18 ods. 4&nbsp;ZOS).
            <br />
            <br />
            4. V&nbsp;prípade reklamácie tovaru vystaví predávajúci reklamačný protokol v&nbsp;2&nbsp;vyhotoveniach,
            1&nbsp;vyhotovenia obdrží kupujúci, 1&nbsp;vyhotovenie zostane v&nbsp;predajni.
            <br />
            <br />
            5. Kupujúci dopraví reklamovaný tovar na reklamačné miesto za účelom posúdenia opodstatnenosti reklamácie
            okrem prípadu, že predávajúci sa rozhodne posúdiť opodstatnenosť reklamácie inak.
            <br />
            <br />
            6. Reklamácia sa nevzťahuje na prirodzené starnutie a&nbsp;bežné opotrebovanie výrobku.
          </p>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            V. Neodstrániteľné vady
          </Text>
          <p>
            1. Ak ide o&nbsp;vadu, ktorú nemožno odstrániť a&nbsp;ktorá bráni tomu, aby sa vec mohla riadne užívať ako
            vec bez vady, má kupujúci právo na výmenu veci alebo má právo od kúpnej zmluvy odstúpiť.
            <br />
            <br />
            2. Ak ide o&nbsp;neodstrániteľnú vadu, pri ktorej možno vec používať, má kupujúci právo na primeranú zľavu
            z&nbsp;ceny tovaru. Pri určovaní výšky primeranej zľavy sa prihliada na charakter vady, stupeň a&nbsp;spôsob
            opotrebenia veci, dĺžku používania veci a&nbsp;možnosti jeho ďalšieho užívania.
          </p>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            VI. Alternatívne riešenie spotrebiteľských sporov
          </Text>
          <p>
            Od&nbsp;1. februára 2016 funguje&nbsp;na Slovensku nový systém alternatívneho riešenia spotrebiteľských
            sporov, vytvorený&nbsp;zákonom č. 391/2015 Z. z. o&nbsp;alternatívnom riešení spotrebiteľských
            sporov&nbsp;(ARS).
          </p>
          <br />
          <p>
            Pokiaľ spotrebiteľ nie je spokojný s&nbsp;tým, ako mu predávajúci vybavil reklamáciu, alebo sa domnieva, že
            predávajúci porušil jeho práva, má možnosť obrátiť sa na predávajúceho&nbsp;
            <BoldText>so žiadosťou o&nbsp;nápravu.&nbsp;</BoldText>
            Ak na túto žiadosť predávajúci do 30 dní od dňa odoslania neodpovie alebo na ňu odpovie zamietavo,
            spotrebiteľ sa môže s&nbsp;návrhom na začatie ARS obrátiť sa príslušný subjekt; možnosť obrátiť sa na súd
            tým nie je dotknutá.
          </p>
          <br />
          <p>
            Subjekt návrh preskúma, aby zistil, či môže začať ARS alebo či&nbsp;
            <BoldText>návrh odmietne</BoldText>
            &nbsp;na základe dôvodov, ktoré má stanovené v&nbsp;pravidlách ARS. O odmietnutí subjekt spotrebiteľa
            informuje.
          </p>
          <br />
          <p>
            <BoldText>Po začatí ARS</BoldText>
            &nbsp;subjekt kontaktuje obe strany sporu a&nbsp;snaží sa spor medzi nimi vyriešiť, a&nbsp;to hľadaním
            kompromisov tak, aby boli dodržané práva dotknutých osôb. Pri ARS subjekt v&nbsp;záujme čo najrýchlejšieho
            vyriešenia sporu oslovuje strany sporu najmä elektronicky alebo telefonicky; subjekt by mal spor vyriešiť
            do&nbsp;
            <BoldText>90 dní</BoldText>
            &nbsp;(pri zložitých prípadoch je možné predĺženie lehoty).
          </p>
          <br />
          <p>
            Príslušným subjektom na ARS s predávajúcim SINTRA šport, s.r.o., Pluhová 2, 831 03 Bratislava, IČO:
            35935448, DIČ: 2022001839, IČ DPH: SK2022001839 je Slovenská obchodná inšpekcia, Prievozská 32, 827 99
            Bratislava 27, IČO: 17331927, www.soi.sk alebo iný príslušný subjekt zapísaný v zozname subjektov ARS
            vedenom Ministerstvom hospodárstva Slovenskej republiky (zoznam je dostupný na stránke http://www.mhsr.sk);
            spotrebiteľ má právo voľby, na ktorý z uvedených subjektov ARS sa obráti.
          </p>
          <br />
          <p>
            <Text fontWeight="bold" textColor={ColorsMap.primary}>
              SINTRA šport, s.r.o.
            </Text>
          </p>
        </>
      )
    case 'en':
      return (
        <>
          <Text fontSize="xl" textColor={ColorsMap.primary} fontWeight="bold" m="2.5rem auto">
            Terms and conditions
          </Text>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            I. General provisions
          </Text>
          <Text>
            1. The following general terms and conditions apply to the business relationship between the buyer and the
            seller: <BoldText>SINTRA šport, s.r.o.</BoldText>, Pluhová 2, 831 03 Bratislava, IČO: 35935448, DIČ:
            2022001839, IČ DPH: SK2022001839, the company is registered in the Commercial Register: District Court
            Bratislava 1, Section Sro, file no .: 36034/B (hereinafter only the seller and the buyer). Name of
            supervisory organization: SOI, Prievozská 22, Bratislava.
          </Text>
          <br />
          <Text>
            2. The conditions further define and specify the rights and obligations of the seller and the buyer and, in
            their current wording, form a fundamental part of the purchase contract. If a permanent purchase contract is
            not agreed between the seller and the buyer in writing, the electronic order in the e-shop is considered a
            proposal to conclude a contract between the buyer and the seller, which the seller accepts by confirming the
            order.
          </Text>
          <br />
          <Text>
            3.&nbsp;The seller is entitled to change the business conditions, which come into force and effect on the
            day of their publication on the website. Contractual relationships that arose before the new business took
            effect conditions are governed by the business conditions valid and effective until the creation of these
            contracts relationships.
          </Text>
          <br />
          <Text>
            4.&nbsp;
            <BoldText>The seller </BoldText>
            is the operator of the e-shop.
          </Text>
          <br />
          <Text>
            5.&nbsp;
            <BoldText>The buyer </BoldText>
            is a natural or legal person who has sent an electronic order, processed by the e-shop system, via their
            shopping cart after their own authorization.
          </Text>
          <Text>
            <br />
            6.&nbsp;
            <BoldText>Goods </BoldText>
            are all products listed in the valid overview on the e-shop website.
          </Text>
          <br />
          <Text>
            7.&nbsp;
            <BoldText>Electronic order </BoldText>
            means a sent electronic form containing information about the buyer, a list of ordered goods from the
            store's selection and the price of these goods, processed by the store's system.
          </Text>
          <br />
          <Text>
            8.&nbsp;
            <BoldText>Registration </BoldText>
            means registering the customer before ordering the goods.
          </Text>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            II. Ordering goods
          </Text>
          <Text>
            1. Ordering in the e-shop is made through the
            <BoldText> shopping cart</BoldText>.
          </Text>
          <br />
          <Text>
            2. When ordering goods, the buyer fills in the required fields in the form, otherwise the order can not be
            confirmed.
          </Text>
          <br />
          <Text>3. Orders are listed in the system in the order in which they arrive.</Text>
          <br />
          <Text>
            4. The condition for the validity of the electronic order is the
            <BoldText> correct</BoldText>
            &nbsp;and&nbsp;
            <BoldText>thorough completion</BoldText>
            &nbsp;of all data required by the registration form and the requisites, which will enable seamless delivery
            of the shipment.
          </Text>
          <br />
          <Text>
            5. All received electronic orders are considered as a<BoldText> proposal to conclude a contract </BoldText>
            and are binding.
          </Text>
          <br />
          <Text>
            6. By confirming the electronic order by the system, the proposal for concluding the contract will be
            accepted by the seller. At the moment of acceptance of the proposal for concluding the contract, the
            purchase contract will be concluded between the seller and the buyer. The acceptance takes effect at the
            time of acquiring and payment of the goods by the buyer.
          </Text>
          <br />
          <Text>
            7. If the ordered goods are not in stock and it will not be possible to order them for various reasons so
            that they are delivered to the buyer within the delivery period, the seller will notify the buyer by e-mail
            or telephone of the details. In such case, the buyer has the right to cancel or modify his order by mutual
            agreement.
          </Text>
          <br />
          <Text>
            8.
            <BoldText> The value </BoldText>
            of the goods stated on the confirmed order is
            <BoldText> final</BoldText>.
          </Text>
          <br />
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            III. Prices of goods
          </Text>
          <p>
            1. The prices of goods are given for each product in-store in EUR with VAT. The seller undertakes to comply
            with the prices given in the confirmed order of the buyer.
          </p>
          <br />
          <p>
            2. The seller has the right to update and change prices in the event of changes in prices on the market or
            from its supplier, etc. even without notice.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            IV. Method of payment
          </Text>
          <p>
            1. Payments for goods are made in cash, respectively cash on delivery to the courier upon delivery of the
            goods.
          </p>
          <br />
          <p>2. The buyer receives an invoice as a tax document, which must be submitted in case of a complaint.</p>
          <br />
          <p>&nbsp;</p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" mb="1rem">
            V. Delivery of goods
          </Text>
          <p>
            1. The point of conduct of the contract means the residence (domicile) or place of business of the buyer
            specified in the registration form. The goods ordered by the buyer will be delivered to the buyer through
            the services of third parties.
          </p>
          <br />
          <p>
            2. The seller will deliver the goods to the buyer within <BoldText>1-14 working days</BoldText>. In
            exceptional cases, the time for delivery of the goods may be longer, with the buyer informed on time.
          </p>
          <br />
          <p>
            3. The seller charges a fee of <BoldText>5,-&nbsp;&euro; with VAT </BoldText>added to the value of the goods
            sent for transport za dopravu,
            <BoldText> free shipping for orders over 100, - €.</BoldText>
          </p>
          <br />
          <p>
            4. In the event that the order cannot be fully processed at one time, the buyer will pay postage according
            to the amount specified in the order. Postage and cash on delivery are not paid for additionally sent goods
            from a partially completed order.
          </p>
          <br />
          <p>
            5. The courier company is responsible for the shipment until it is handed over to the buyer. He/she is
            obliged to{' '}
            <BoldText>
              inspect the shipment upon receipt and in case of visible damage or even loss of part of the goods, he/she
              will write a complaint protocol with the carrier and will not accept the shipment
            </BoldText>
            . As soon as the courier company returns the shipment, the seller will ship new goods to the buyer.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            VI. Return of goods
          </Text>
          <p>
            1. The buyer has the right to return the goods without giving a reason within
            <BoldText> 14 days </BoldText>
            of delivery of the goods. The consumer may exercise the right to withdraw from the contract with the seller
            in paper form or by e-mail at
            <u>
              <a href="mailto:kalo@tn.sintra.sk"> ivana@tn.sintra.sk </a>
            </u>
            . The consumer can use
            <a href="https://data.werco.cz/eshop_sk/dokumenty/odstupenie_spotrebitela_od_zmluvy.pdf">
              <strong> the withdrawal form</strong>
            </a>
            . If you decide to do so, send us a written statement of withdrawal together with the goods, stating the
            order number, date of purchase and account number for financial settlement. In this case, the buyer will
            send the goods together with the proof of purchase no later than 14 days from the date of withdrawal from
            the contract by post to the registered office:&nbsp;
            <BoldText>SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín.</BoldText>
          </p>
          <br />
          <p>
            Alternatively, hand over the goods in person at the store (dispensing point). When returning, please send
            (hand over) the goods undamaged, including documentation, accessories, etc. Upon withdrawal from the
            contract, you bear only the cost of returning the goods to the seller. The consumer is responsible for the
            reduction in the value of the goods which has arisen as a result of such treatment of the goods as is beyond
            the scope of the treatment necessary to determine the characteristics and functionality of the goods. The
            seller undertakes to return the price paid for the relevant goods within 14 days from the date of delivery
            of the notice of withdrawal from the contract to the seller.
          </p>
          <br />
          <p>2. The buyer does not send the returned goods cash on delivery!</p>
          <br />
          <p>
            3. Upon agreement, the refund can be made in the form of an exchange for other goods in the corresponding
            value, which will be sent either with another customer order or separately. If the goods are sent separately
            (in case of exchange of goods)
            <BoldText> postage will not be charged</BoldText>, but only if this is the
            <BoldText> first exchange</BoldText>.
          </p>
          <br />
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            VII. Refunds
          </Text>
          <p>
            1. The buyer is obliged to inspect all delivered goods and check their completeness without undue delay
            after delivery. The buyer is obliged to immediately notify the seller of any discrepancies between the
            delivered goods and the goods stated on the accompanying document.
            <br />
            <br />
            2. The buyer will send the claimed product together with a copy of the invoice to the seller's address:{' '}
            <BoldText>SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín</BoldText>
            <br />
            <br />
            3. Complaints of goods will be handled in accordance with the Civil Code of the Slovak Republic and Act no.
            250/2007 Coll. on consumer protection as amended.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            VIII. Final provisions
          </Text>
          <Text>
            1. Legal relations and conditions not expressly regulated here, as well as any disputes arising from the
            non-fulfillment of these conditions are governed by the relevant provisions of the Civil Code of the Slovak
            Republic. The rights of the buyer in relation to the seller arising from Act no. 250/2007 Coll. on consumer
            protection, as amended, remain unaffected by these conditions.
          </Text>
          <br />
          <p>
            2. Neither the seller nor the buyer shall be liable for late performance of its obligations under these
            Terms if such delay was caused by "force majeure" or circumstances excluding liability, and such party shall
            be entitled to a reasonable extension of the period for performance of its obligations.
          </p>
          <br />
          <p>
            3. The buyer declares that he/she agrees in accordance with Art. § 7 par. 1 of Act no. 428/2002 Coll. on the
            protection of personal data, as amended, with the processing and storage of personal data that are necessary
            in the activities of the seller and the processing of them in all its information systems. The seller
            undertakes to handle and dispose of the buyer's personal data in accordance with the valid legal regulations
            of the Slovak Republic. The buyer grants the seller this consent for an indefinite period.
          </p>
          <br />
          <p>
            4. The buyer agrees to provide personal data to the company
            <BoldText>SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín</BoldText>
            &nbsp;which are necessary for its activities, in particular for the activities listed in the Commercial
            Register. The buyer may revoke the consent to the processing of personal data at any time in writing. The
            consent expires within 1 month from the delivery of the revocation of consent by the buyer to the seller.
          </p>
          <Text fontWeight="bold" textColor={ColorsMap.primary} fontSize="l" my="1rem">
            Return policy
          </Text>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            I. General provisions
          </Text>
          1. The seller is responsible for the defects of the sold item when it is taken over by the buyer. For used
          items, the seller is not responsible for defects caused by their use or wear. In the case of items sold at a
          lower price, the seller is not liable for the defect for which a lower price was agreed.
          <br />
          <br />
          2. Ownership of the purchased item passes to the buyer at the time of payment of the purchase price for the
          goods. In the case of self-service sales, the ownership of the purchased item is transferred at the moment of
          payment of the purchase price for the goods.
          <br />
          <br />
          3. After taking over the goods, the buyer is obliged to check their quantity, quality and packaging and
          immediately (without undue delay) notify the seller of any deficiencies. (§599 OZ)
          <br />
          <br />
          4. The warranty applies only to the product listed on the delivery note of the invoice and covers all defects
          found during the warranty period caused by a defect in material, defective construction or incorrect
          processing. The warranty covers hidden defects on the subject of delivery, but does not cover defects caused
          by unprofessional handling or unprofessional intervention on the goods after its delivery to the buyer or his
          representative. Subsequent damage to the surface of the delivery item by scratching, etc. is not considered a
          latent defect. (§ 619 OZ)
          <br />
          <br />
          5. By acquiring ownership, the risk of accidental destruction, destruction and damage to the thing passes to
          the buyer.
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            II. Deadlines for making a complaint
          </Text>
          1. The warranty on the goods is 24 months. The warranty periods begin to run from the date of receipt of the
          goods by the buyer (§ 621 of the Civil Code, hereinafter referred to as "Trademark"). The warranty period also
          applies to products sold on sale or at a discount. However, if a discount is granted due to a certain defect
          of the goods, then this defect cannot be claimed. (§ 619 OZ)
          <br />
          <br />
          2. If the period of use (expiry date) is marked on the goods sold, their packaging or instructions, the
          warranty period does not end before the expiry of this period.
          <br />
          <br />
          3. If the sold goods are covered by a warranty period longer than 24 months, the seller is obliged to issue
          the warranty card to the buyer at the time of sale by marking the warranty period. The warranty card states
          the conditions and scope of this warranty.
          <br />
          <br />
          4. The rights from liability for defects must be exercised by the buyer during the warranty period, otherwise
          these rights expire.
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            III. Loss of warranty claims
          </Text>
          <p>
            Nároky plynúce zo záruky zanikajú, ak tovar bol :<br />
            &middot; Damaged by the consumer's transport,
            <br />
            &middot; Mechanically damaged by improper handling or improper storage after taking over the goods,
            <br />
            &middot; Dirty and unprofessionally cleaned,
            <br />
            &middot; Damaged by unprofessional interference in its construction,
            <br />
            &middot; Degraded by excessive use or has been used for a purpose other than normal use,
            <br />
            &middot; Damaged from pets etc. ...
          </p>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            IV. Place of claim
          </Text>
          <p>
            1. Obvious defects must be reported immediately at the seller's registered office{' '}
            <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
              SINTRA šport, s.r.o., Zlatovská 1962, 911 05 Trenčín
            </Text>
            (complaint place) by submitting proof of purchase and payment of goods. (Section 18 (1) of the Consumer
            Protection Act, hereinafter referred to as "ZOS")
            <br />
            <br />
            2. The seller is obliged to handle the complaint immediately, in complex cases within 3 working days and in
            justified cases within 30 days from the application of the complaint § 18 par. 4ZOS quote: ”If the consumer
            lodges a complaint, the seller or an employee authorized by him or a designated person is obliged to inform
            the consumer of his rights under the general regulation. Based on the consumer's decision, which of these
            rights the consumer exercises, he is obliged to determine the method of handling the complaint according to
            § 2 letter. m) immediately, in complex cases no later than 3 working days from the date of the complaint, in
            justified cases, especially if a complex technical assessment of the condition of the product or service is
            required, no later than 30 days from the date of the complaint. After determining the method of handling the
            complaint, the complaint will be settled immediately, in justified cases, the complaint can be settled
            later; however, the settlement of the complaint may not take longer than 30 days from the date of the
            complaint. After the expiry of the time limit for settling the complaint, the consumer has the right to
            withdraw from the contract or has the right to exchange the product for a new product. “
            <br />
            <br />
            3. Complaint handling may not take longer than 30 days (§ 18 para. 4 ZOS).
            <br />
            <br />
            4. In the case of a complaint about the goods, the seller will issue a complaint report in 2 copies, 1 copy
            will be received by the buyer, 1 copy will remain in the store.
            <br />
            <br />
            5. The buyer will transport the claimed goods to the complaint place in order to assess the validity of the
            complaint, unless the seller decides to assess the validity of the complaint otherwise.
            <br />
            <br />
            6. The complaint does not cover natural aging and normal wear and tear of the product.
          </p>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            V. Irreparable defects
          </Text>
          <p>
            1. In the case of a defect which cannot be removed and which prevents the thing from being properly used as
            a thing without defects, the buyer has the right to exchange the thing or has the right to withdraw from the
            purchase contract.
            <br />
            <br />
            2. In the case of an irreparable defect in which the item can be used, the buyer is entitled to a reasonable
            discount on the price of the goods. In determining the amount of the appropriate discount, the nature of the
            defect, the degree and manner of wear of the thing, the length of use of the thing and the possibility of
            its further use are taken into account.
          </p>
          <Text my="0.5rem" fontWeight="bold" textColor={ColorsMap.primary}>
            VI. Alternative resolution of consumer disputes
          </Text>
          <p>
            Since February 1, 2016, a new system of alternative resolution of consumer disputes has been operating in
            Slovakia, created by Act no. 391/2015 Coll. on Alternative Dispute Resolution (ADR). If the consumer is not
            satisfied with how the seller has handled the complaint to him or considers that the seller has violated his
            rights, he has the opportunity to turn to the seller for redress. If the seller does not respond to this
            request within 30 days from the date of dispatch or responds in a negative manner, the consumer may apply to
            the competent body for a proposal to initiate ADR; the possibility of going to court is not affected. The
            entity examines the proposal to see if it can start an ADR or if it rejects the proposal on the grounds set
            out in the ADR rules. The entity shall inform the consumer of the refusal. Once the ADR has started, the
            entity contacts both parties to the dispute and seeks to resolve the dispute between them by seeking
            compromises so as to respect the rights of the persons concerned. In the case of ADR, the entity addresses
            the parties to the dispute, in particular electronically or by telephone, in order to resolve the dispute as
            quickly as possible; the subject should resolve the dispute within 90 days (extension of the deadline is
            possible in complex cases). Competent entity on ADR with the seller SINTRA šport, s.r.o., Pluhová 2, 831 03
            Bratislava, ID: 35935448, VAT ID: 2022001 839, VAT ID: SK2022001839 is the Slovak Trade Inspection,
            Prievozská 32, 827 99 Bratislava 27, VAT ID: 17331927, www.soi.sk or another relevant entity registered in
            the list of ADR entities maintained by the Ministry of Economy of the Slovak Republic (the list is available
            at http://www.mhsr.sk); the consumer has the right to choose which of these ADR entities to turn to.
          </p>
          <br />
          <p>
            <Text fontWeight="bold" textColor={ColorsMap.primary}>
              SINTRA šport, s.r.o.
            </Text>
          </p>
        </>
      )
  }
}

const Terms = ({ state }) => {
  const { t, lang } = useTranslation('common')

  return (
    <PageLayout title={`${t('title:terms')} | ${state.settings.name}`}>
      <Path pathLinks={[<span>{t('title:terms')}</span>]} />
      <Wrapper>
        <TermsContent lang={lang} />
      </Wrapper>
    </PageLayout>
  )
}

const mapStateToProps = (state: { state: object }) => {
  return {
    state,
  }
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const reduxStore = initializeStore({})
  const { dispatch } = reduxStore

  const token = ctx.req.cookies.token || null

  await dispatch(getSettings({ token }))
  return { props: { initialReduxState: reduxStore.getState() } }
}

export default connect(mapStateToProps)(Terms)

